import React, { useContext } from 'react';
import { ParameterContext } from '../contexts/ParameterContext';

export function Footer() {
    const { parameters } = useContext(ParameterContext)

    let privacyStatementLink = '/#';

    if (parameters && parameters.nomParameters) {
        privacyStatementLink = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'PRIVACY_STATEMENT_LINK');
    } 

    return (
        <div className="footer">
            <div className="">© 2015 - {new Date().getFullYear()} IS Jsc.,@ Община  {parameters.municipality.obshtina_name} </div>
            <div className="">
                <a target="_blank" href={`${privacyStatementLink.value}`}>
                    Декларация за поверителност
                    </a>
            </div>
        </div>
    );
  
}

export default Footer;
